import { appConfig } from "src/config";
import { useTranslate } from "src/i18n";

export const useMainBlockTranslate = () => {
  const { t } = useTranslate();

  const title = t("outsourcing.main_block.title", "Разработка магазинов");

  const subtitles = [
    t(
      "outsourcing.main_block.subtitle_text_1",
      "В {brand} мы создаем не просто платформы, а целостные экосистемы для интернет-магазинов, обеспечивая безупречный пользовательский опыт, производительность и безопасность.",
      { brand: appConfig.displayName },
    ),
    t(
      "outsourcing.main_block.subtitle_text_2",
      "Наш подход основан на интеграции передовых технологий, автоматизации и персонализации, помогая бизнесу расти и адаптироваться к изменениям на рынке.",
    ),
    t(
      "outsourcing.main_block.subtitle_text_3",
      "{brand} — ваш надежный партнер в успешной электронной коммерции.",
      { brand: appConfig.displayName },
    ),
    t(
      "outsourcing.main_block.subtitle_text_4",
      "Предлагаем вам узнать подробнее ниже по странице.",
    ),
  ];

  return { title, subtitles };
};
